import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Navbar from "../../../components/navbar";
import Usertab from "../../../components/user-tab";
import Footer from "../../../components/footer";
import Switcher from "../../../components/switcher";
import ScrollToTop from "../../../components/scroll-to-top";
import { useSelector } from "react-redux";
import { FiEdit, FiMapPin, FiPhone } from "../../../assets/icons/vander";
import {
  useGetUserProfileQuery,
  useUpdateProfileMutation,
} from "../../../redux/services/profile";

export default function UserBilling() {
  const user = useSelector((state) => state.auth.user);
  const {
    data: profile,
    error,
    isFetching: isLoading,
  } = useGetUserProfileQuery({ filter: { id: user.id } });

  const [isEditingBilling, setIsEditingBilling] = useState(false);
  const [isEditingShipping, setIsEditingShipping] = useState(false);
  const [isEditingShippingPhone, setIsEditingShippingPhone] = useState(false);
  const [isEditingBillingPhone, setIsEditingBillingPhone] = useState(false);
  const [billingAddress, setBillingAddress] = useState(
    profile?.[0]?.billing_address || ""
  );
  const [shippingAddress, setShippingAddress] = useState(
    profile?.[0]?.shipping_address || ""
  );
  const [billingphoneNumber, setBillingPhoneNumber] = useState(
    profile?.[0]?.billing_phone_number || ""
  );
  const [shippingphoneNumber, setShippingPhoneNumber] = useState(
    profile?.[0]?.Shipping_phone_number || ""
  );
  const [updateProfile] = useUpdateProfileMutation();

  useEffect(() => {
    setBillingAddress(profile?.[0]?.billing_address);
    setShippingAddress(profile?.[0]?.shipping_address);
    setBillingPhoneNumber(profile?.[0]?.billing_phone_number);
    setShippingPhoneNumber(profile?.[0]?.shipping_phone_number);
  }, [profile]);

  const handleBlur = () => {
    setIsEditingBilling(false);
    setIsEditingBillingPhone(true);

    updateProfile({
      id: profile[0].id,
      billing_address: billingAddress,
    });
  };

  const handleBlurBilingPhoneNumber = () => {
    setIsEditingBillingPhone(false);

    updateProfile({
      id: profile[0].id,
      billing_phone_number: billingphoneNumber,
    });
  };
  const handleBlurShippingPhoneNumber = () => {
    setIsEditingShippingPhone(false);

    updateProfile({
      id: profile[0].id,
      shipping_phone_number: shippingphoneNumber,
    });
  };

  const handleBlurShipping = () => {
    setIsEditingShipping(false);
    setIsEditingShippingPhone(true);

    updateProfile({
      id: profile[0].id,
      shipping_address: shippingAddress,
    });
  };

  const handleEdit = () => setIsEditingBilling(true);
  const handleEditShipping = () => setIsEditingShipping(true);

  return (
    <>
      <Navbar navClass="defaultscroll is-sticky" />
      <section className="relative lg:pb-24 pb-16 md:mt-[84px] mt-[70px]">
        <div className="md:container container-fluid relative">
          <div className="relative overflow-hidden md:rounded-md shadow dark:shadow-gray-700 h-52 bg-[url('../../assets/images/hero/pages.jpg')] bg-center bg-no-repeat bg-cover"></div>
        </div>

        <div className="container relative md:mt-24 mt-16">
          <div className="md:flex">
            <Usertab profile={profile} />

            <div className="lg:w-3/4 md:w-2/3 md:px-3 mt-6 md:mt-0">
              <div className="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900">
                <h6 className="text-slate-400 mb-0">
                  The following addresses will be used on the checkout page by
                  default.
                </h6>
                <div className="grid lg:grid-cols-2 grid-cols-1 gap-6 mt-6">
                  <div className="">
                    <div className="flex items-center mb-4 justify-between">
                      <h5 className="text-xl font-medium">Billing Address:</h5>
                      <button
                        onClick={handleEdit}
                        className="text-orange-500 text-lg"
                      >
                        <FiEdit className="size-4" />
                      </button>
                    </div>
                    <div className="pt-4 border-t border-gray-100 dark:border-gray-700">
                      <p className="text-lg font-medium mb-2">
                        {profile && profile[0]?.user_name}
                      </p>

                      <ul className="list-none">
                        <li className="flex ms-0">
                          <FiMapPin className="size-4 me-2 mt-1"></FiMapPin>
                          {isEditingBilling ? (
                            <input
                              className="text-slate-400"
                              value={billingAddress}
                              onChange={(e) =>
                                setBillingAddress(e.target.value)
                              }
                              onBlur={handleBlur}
                              autoFocus
                            />
                          ) : (
                            <p className="text-slate-400">
                              {billingAddress ? billingAddress : "N/A"}
                            </p>
                          )}
                        </li>

                        <li className="flex ms-0 mt-1">
                          <FiPhone className="size-4 me-2 mt-1"></FiPhone>
                          {isEditingBillingPhone ? (
                            <input
                              className={`text-slate-400 ${
                                isEditingBillingPhone
                                  ? "border border-blue-500"
                                  : ""
                              }`}
                              value={billingphoneNumber}
                              onChange={(e) => setBillingPhoneNumber(e.target.value)}
                              onBlur={handleBlurBilingPhoneNumber}
                              autoFocus
                            />
                          ) : (
                            <p className="text-slate-400">
                              {billingphoneNumber ? billingphoneNumber : "N/A"}
                            </p>
                          )}
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="">
                    <div className="flex items-center mb-4 justify-between">
                      <h5 className="text-xl font-medium">Shipping Address:</h5>
                      <button
                        onClick={handleEditShipping}
                        className="text-orange-500 text-lg"
                      >
                        <FiEdit className="size-4" />
                      </button>
                    </div>
                    <div className="pt-4 border-t border-gray-100 dark:border-gray-700">
                      <p className="text-lg font-medium mb-2">
                        {profile && profile[0]?.user_name}
                      </p>

                      <ul className="list-none">
                        <li className="flex ms-0">
                          <FiMapPin className="size-4 me-2 mt-1"></FiMapPin>
                          <p className="text-slate-400">
                            {isEditingShipping ? (
                              <input
                                className="text-slate-400"
                                value={shippingAddress}
                                onChange={(e) =>
                                  setShippingAddress(e.target.value)
                                }
                                onBlur={handleBlurShipping}
                                autoFocus
                              />
                            ) : (
                              <p className="text-slate-400">
                                {shippingAddress ? shippingAddress : "N/A"}
                              </p>
                            )}
                          </p>
                        </li>

                        <li className="flex ms-0 mt-1">
                          <FiPhone className="size-4 me-2 mt-1"></FiPhone>
                          {isEditingShippingPhone ? (
                            <input
                              className={`text-slate-400 ${
                                isEditingShippingPhone
                                  ? "border border-blue-500"
                                  : ""
                              }`}
                              value={shippingphoneNumber}
                              onChange={(e) => setShippingPhoneNumber(e.target.value)}
                              onBlur={handleBlurShippingPhoneNumber}
                            />
                          ) : (
                            <p className="text-slate-400">
                              {shippingphoneNumber ? shippingphoneNumber : "N/A"}
                            </p>
                          )}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      {/* <Switcher /> */}
      <ScrollToTop />
    </>
  );
}
